// 消息中心接口
import Ajax from "./ajax";

//  获取班级消息
export const getClassMessage = (data) =>Ajax.get(`/fs-user-class-message`, data);
//  获取系统消息
export const getMessageReceives = (data) =>Ajax.get(`/fs-user-receives`, data);
//  获取答疑消息
export const getCourseMessage = (data) =>Ajax.get(`/fs-user-course-message`, data);

//  查看班级消息更新状态
export const updateClassMessageRead = (data) =>Ajax.post(`/fs-user-class-message-read`, data);
//  查看系统消息更新状态
export const updateMessageReceivesRead = (data) =>Ajax.post(`/fs-user-receives-read`, data);
//  查看答疑消息更新状态
export const updateCourseMessageRead = (data) =>Ajax.post(`/fs-user-course-message-read`, data);
